export const API_URL = (process.env.NODE_ENV === 'production') ? '' : 'http://192.168.6.1:9000/'
export default API_URL
